module.exports = __webpack_public_path__ + "static/media/british-flag.497e7cd1.svg";